<template>
  <!-- I haven't made any change to this template. This is only copy and paste from doc site. -->
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4>
          <div class="form-control">
            <div style="position: relative">
              <input class="mb-0" placeholder="Search" v-model="input.search" type="text" />
              <v-btn style="position: absolute; right: 5px; top: 5px" class="ma-0" icon
                ><v-icon color="primary">search</v-icon></v-btn
              >
            </div>
          </div>
        </v-flex>
        <v-flex xs8>
          <div class="text-xs-right">
            <importxlsx @onChange="importCsv"></importxlsx>
            <exportxlsx v-model="xlsxdata"></exportxlsx>
          </div>
        </v-flex>
      </v-layout>
      <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr style="cursor: pointer" @click="showDetail(props.item)">
            <td style="width: 150px !important">
              <div>
                <v-img :src="props.item.image_url"></v-img>
              </div>
            </td>
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.keyword }}</td>
            <td>{{ props.item.description }}</td>
            <td class="text-xs-right">
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detaildialog" width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="detaildialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div><ProductDetail></ProductDetail></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import ProductDetail from './ProductDetail.vue'
export default {
  components: {
    exportxlsx,
    importxlsx,
    ProductDetail,
  },
  data: () => ({
    detaildialog: false,

    detaildata: '',
    input: {
      search: '',
    },
    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Title',
        align: 'center',

        value: 'title',
      },
      { text: 'Category', align: 'center', value: 'category' },
      { text: 'Keyword', align: 'center', value: 'Keyword' },
      { text: 'Short Description', align: 'center', value: 'description' },
      { text: 'Actions', align: 'center', value: 'name', sortable: false },
    ],
    items: [
      {
        image_url: 'https://www.sinthanee.com/image/cache/11%20it/D413IA-EB303TS-1000x1000.png',
        title: 'titletest',
        category: 'test cat',
        keyword: 'keywordtest',
        description: 'xxxxxxxxxxxxx',
      },
    ],
  }),

  computed: {
    ...mapGetters(['selectedBot']),
    xlsxdata() {
      var json = this.items.map((el) => {
        return {
          'Image url': el.image_url,
          Title: el.title,
          Category: el.category,
          Keyword: el.keyword,
          'Short Description': el.description,
        }
      })
      return json
    },
  },

  methods: {
    showDetail(item) {
      this.detaildialog = true
      this.detaildata = item
    },
    importCsv(file) {
      console.log(file)
    },
    deleteItem(item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/Product.vue